import React from 'react';
import { useParams } from 'react-router-dom';
import { FamilyFinderProvider } from '../context/FamilyFinderContext';
import FamilyFinderPage from './FamilyFinderPage';

const FamilyFinderRoute = () => {
  const { childId } = useParams();
  return (
    <FamilyFinderProvider childId={childId}>
      <FamilyFinderPage />
    </FamilyFinderProvider>
  );
};

export default FamilyFinderRoute;
